import { render, staticRenderFns } from "./DirectorySpotsView.vue?vue&type=template&id=a87c32be&lang=html&"
import script from "./DirectorySpotsView.vue?vue&type=script&lang=ts&"
export * from "./DirectorySpotsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports